/** Default favors teams with many business cards / sticks without drowning mobile. */
export const PRODUCTS_PAGE_SIZE_DEFAULT = 20;

export const PRODUCTS_PAGE_SIZE_OPTIONS = [10, 20, 50] as const;
